module.exports = __webpack_public_path__ + "assets/40618799e06e90aa7617681b3ac30e6f.svg";